import { Action, createReducer, on } from '@ngrx/store';

import * as SiteActions from './site.actions';

import { Site } from '@shared/models';

export const siteFeatureKey = 'site';

export interface SiteState {
  activeSite: Site;
  error: string;
}

export const initialState: SiteState = {
  activeSite: null,
  error: null,
};

const siteReducer = createReducer(
  initialState,
  on(SiteActions.setActiveSiteSuccess, (state, data) => ({
    ...state,
    error: null,
    activeSite: data.data,
  })),
  on(
    SiteActions.setActiveSiteFailure,
    SiteActions.updateSiteFailure,
    (state, data) => {
      let error = 'There was an error';
      if (data.error?.error?.detail) {
        error = data.error.error.detail;
      } else if (data.error?.message) {
        error = data.error.message;
      }
      return {
        ...state,
        error,
      };
    }
  ),
  on(SiteActions.clearSiteState, () => {
    return initialState;
  })
);

export function reducer(state: SiteState | undefined, action: Action) {
  return siteReducer(state, action);
}
